import LoginScreen from '@/pages/login/login_screen';
import type { ReactNode } from 'react';
import { useUserStore } from '@/state/user_state';
import { AuthService } from '../services/auth/auth_service';
import { message } from 'antd';
import LoaderComponent from 'shared-lib/components/loader.js';

interface AuthPageWrapperProps {
    children: ReactNode;
}

export default function AuthPageWrapper({ children }: AuthPageWrapperProps) {
    const user = useUserStore();
    const searchParams = new URLSearchParams(window.location.search);
    const setSearchParams = (params: Record<string, string>) => {
        const url = new URL(window.location.href);
        url.search = new URLSearchParams(params).toString();
        window.history.replaceState({}, '', url.toString());
    };

    if (user.isLoading) {
        return <LoaderComponent />;
    }

    if (searchParams.get('token')) {
        user.setCredentials(null);
        user.setUser(null);
        setSearchParams({});

        AuthService.getInstance().exchangeOneTimeToken(searchParams.get('token')!).then(() => {
            message.success('Erfolgreich mit Einmal-Link angemeldet!');
            // Bestellung-scoped one-time tokens carry a `bestellungId`
            // claim; we redirect to the Bestellung page so the customer
            // lands directly on the confirmation surface (workflow §3).
            const u = useUserStore.getState().user;
            const bestellungId = (u as { bestellungId?: string | null } | null)?.bestellungId;
            if (bestellungId) {
                window.history.replaceState({}, '', `/bestellung/${bestellungId}`);
            }
        }).catch(() => {
            message.error('Der Einmal-Link ist ungültig oder abgelaufen.');
        });
        return <LoaderComponent />;
    }

    if (!user.user) {
        return <LoginScreen />;
    }

    return (
        <>
            {children}
        </>
    );
}
